import { fmtDate } from '../../engine/format';
import { t } from '../../engine/i18n';
import type { GameState } from '../../engine/state';
import { dateAtDay } from '../../engine/time';
import { Card } from '../components';

export function JournalTab({ state }: { state: GameState }) {
  const entries = [...state.journal].reverse();
  return (
    <Card title={t('journal.title')}>
      {entries.length === 0 ? (
        <p class="muted">{t('journal.empty')}</p>
      ) : (
        <ol class="journal">
          {entries.map((entry, index) => (
            <li key={`${entry.day}-${index}`}>
              <span class="journal-date">{fmtDate(dateAtDay(state.startDate, entry.day))}</span>
              <span>{t(entry.key, entry.params)}</span>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
